import * as Yup from 'yup'

export const TestSchema = Yup.object({
  idRespuesta: Yup.string().required('Requerido').nullable()
})
